import * as React from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
    noDecimals?: boolean;
    noThousandSeparator?: boolean;
    maxLength?: number;
}

export const NumericFormat100PercentCustom = React.forwardRef<NumericFormatProps, CustomProps>(
    function NumericFormatCustom(props, ref) {
        const { onChange, noDecimals = true, noThousandSeparator = false, ...other } = props;

        // Configuración condicional para decimales
        const decimalSeparator = noDecimals ? undefined : '.';
        const decimalScale = noDecimals ? 0 : 2; // Puedes ajustar el número de decimales según tus necesidades
        const fixedDecimalScale = !noDecimals; // Muestra siempre los decimales si no se deshabilitan

        // Ajusta la longitud máxima según si se permiten decimales
        const inputMaxLength = noDecimals ? 3 : 6; // '100.00' tiene 6 caracteres

        return (
            <NumericFormat
                {...other}
                getInputRef={ref}
                onValueChange={(values) => {
                    let value = values.value;

                    if (!value) {
                        value = "0";
                    } else if (parseFloat(value) > 100) {
                        value = "100";
                    }

                    onChange({
                        target: {
                            name: props.name,
                            value,
                        },
                    });
                }}
                allowNegative={false}
                allowLeadingZeros={false}
                maxLength={inputMaxLength}
                thousandSeparator={noThousandSeparator ? false : ","}
                decimalSeparator={decimalSeparator}
                decimalScale={decimalScale}
                fixedDecimalScale={fixedDecimalScale}
                // allowDecimal={!noDecimals}
                valueIsNumericString
                prefix=""
            />
        );
    },
);
